import * as React from "react"
import { IBlankProps } from "."

export class Blank extends React.PureComponent<IBlankProps> {
  public render() {
    const { double, triple } = this.props
    const style = { width: 328, height: 70 }

    if (double) {
      Object.assign(style, { width: 656 })
    }
    if (triple) {
      Object.assign(style, { width: 984 })
    }

    if (this.props.style) {
      Object.assign(style, this.props.style.lockDiv)
    }

    return <div className="lock-div" style={style} />
  }
}